import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';

const LinkInsertDialog = ({ open, onClose, onSubmit }) => {
    const [url, setUrl] = useState('');
    const [text, setText] = useState('');
    const [error, setError] = useState({ url: '', text: '' });

    const validateUrl = (urlString) => {
        try {
            new URL(urlString);
            return true;
        } catch {
            return false;
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const newError = { url: '', text: '' };
        let hasError = false;

        if (!url.trim()) {
            newError.url = 'URL is required';
            hasError = true;
        } else if (!validateUrl(url.trim())) {
            newError.url = 'Please enter a valid URL (e.g., https://example.com)';
            hasError = true;
        }

        if (!text.trim()) {
            newError.text = 'Link text is required';
            hasError = true;
        }

        if (hasError) {
            setError(newError);
            return;
        }

        onSubmit({ url: url.trim(), text: text.trim() });
        handleClose();
    };

    const handleClose = () => {
        setUrl('');
        setText('');
        setError({ url: '', text: '' });
        onClose();
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && e.ctrlKey) {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
            <DialogTitle>Insert Link</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin='dense'
                    label='URL'
                    type='url'
                    fullWidth
                    variant='outlined'
                    value={url}
                    onChange={(e) => {
                        setUrl(e.target.value);
                        setError((prev) => ({ ...prev, url: '' }));
                    }}
                    onKeyPress={handleKeyPress}
                    error={Boolean(error.url)}
                    helperText={error.url || 'Enter the URL (e.g., https://example.com)'}
                    sx={{ mt: 2 }}
                    placeholder='https://example.com'
                />
                <TextField
                    margin='dense'
                    label='Link Text'
                    type='text'
                    fullWidth
                    variant='outlined'
                    value={text}
                    onChange={(e) => {
                        setText(e.target.value);
                        setError((prev) => ({ ...prev, text: '' }));
                    }}
                    onKeyPress={handleKeyPress}
                    error={Boolean(error.text)}
                    helperText={error.text || 'Enter the text to display for the link'}
                    sx={{ mt: 1 }}
                    placeholder='Click here'
                />
                <div style={{ marginTop: '0.5rem', fontSize: '0.875rem', color: '#666' }}>Tip: Press Ctrl+Enter to insert</div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color='primary'>
                    Cancel
                </Button>
                <Button onClick={handleSubmit} variant='contained' color='primary' disabled={!url.trim() || !text.trim()}>
                    Insert Link
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LinkInsertDialog;
